import React, {useEffect, useState} from 'react';
import styles from "ui-components/src/select/select.module.scss";
import classNames from "classnames";
import Select, { components } from 'react-select';
import { Creatable } from 'react-select';
import _ from "lodash";

const getSelectStyles = (hasError, selectStyles) => ({
    ...selectStyles,
    clearIndicator: (base, state) => ({ ...base, padding: 4, display: state.getValue().length === 1 && 'none' }),
    control: base => ({
        ...base,
        minHeight: 40,
        borderColor: hasError ? '#da0000' : base.borderColor,
        marginBottom: 6,
        marginTop: 10,
        fontSize: 14
    }),
    dropdownIndicator: base => ({ ...base, padding: 4 }),
    input: base => ({ ...base, margin: 0, padding: 0 }),
    menu: base => ({ ...base, fontSize: 13, marginTop: 0 }),
    menuList: base => ({ ...base, maxHeight: 200 }),
    placeholder: base => ({ ...base, fontSize: 14 }),
    singleValue: base => ({ ...base, maxWidth: 'calc(100% - 30px)' }),
    valueContainer: base => ({ ...base, padding: '0px 15px' })
});

const getOptions = () => ({
    Option: props => {
        return (
        <div title={props.data.title}>
            <components.Option {...props}>
                {props.data.label}
                {props.data.secondaryLabel && <br/>}
                <div>{props.data.secondaryLabel}</div>
            </components.Option>
        </div>
    )}
});

export default props => {
    const { containerStyle, charCount, value, maxChars, selectStyles, onChange, label, errorMessage, reference, className, isDisabled, isCreatable, components, ...restProps } = props;
    const [counter, setCounter] = useState(0);

    useEffect(() => {
        if(charCount) {
            setCounter(_.sumBy(value, "value.length"));
        }
    }, [value, charCount]);

    const handleInput = (option, e) => {
        if(charCount && _.isArray(option)){
            if (charCount && (_.sumBy(option, "value.length") > maxChars)) {
                return;
            }
            onChange(option, e);
        } else {
            return onChange(option, e);
        }
    };

    return (<div className={classNames(styles["select-container"], className)} style={containerStyle}>
        <label className={errorMessage ? styles["invalid"] : ''}>
            {label && <div className={styles["title-and-word-counter-container"]}><span>{label}</span>{charCount && <span>{counter}/{maxChars}</span>}</div>}
            {!isCreatable ?
                <Select
                    {...restProps}
                    isDisabled={isDisabled}
                    classNamePrefix="react-select-component"
                    styles={getSelectStyles(errorMessage, selectStyles)}
                    components={components || getOptions()}
                    ref={reference}
                    onChange={handleInput}
                    value={value}
                /> :
                <Creatable
                    {...restProps}
                    isDisabled={isDisabled}
                    classNamePrefix="react-select-component"
                    styles={getSelectStyles(errorMessage, selectStyles)}
                    components={components || getOptions()}
                    ref={reference}
                    onChange={handleInput}
                    value={value}
                />
            }
            <div className={styles.error}>{errorMessage}</div>
        </label>
    </div>);
};
